import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const StatsStrip = () => {
  const [total, setTotal] = useState<number | null>(null);
  useEffect(() => {
    (async () => {
      const { count } = await supabase
        .from("draws")
        .select("*", { count: "exact", head: true });
      if (typeof count === "number") setTotal(count);
    })();
  }, []);
  const totalLabel =
    total !== null
      ? `${total.toLocaleString("pt-BR")}+`
      : "—";
  const stats = [
    { value: totalLabel, label: "Concursos indexados" },
    { value: "4", label: "Loterias cobertas" },
    { value: "100%", label: "Transparência probabilística" },
    { value: "PDF / TXT", label: "Exportação de volantes" },
  ];
  return (
  <div className="mx-auto mb-[72px] max-w-[900px] px-8">
    <h2 className="sr-only">Estatísticas da plataforma LotoTerminal</h2>
    <div className="grid grid-cols-[repeat(auto-fit,minmax(120px,1fr))] gap-px overflow-hidden rounded-2xl border border-lt-border bg-lt-border">
      {stats.map((s, i) => (
        <div key={i} className="bg-lt-bg2 px-4 py-[22px] text-center transition-colors">
          <span className="mb-1 block font-serif text-[28px] text-primary">{s.value}</span>
          <span className="text-[11px] text-lt-cream3">{s.label}</span>
        </div>
      ))}
    </div>
  </div>
  );
};

export default StatsStrip;
